// extracted by mini-css-extract-plugin
module.exports = {"multi-root":"FormDdlItems-module__multi-root__BGlOW","header-root":"FormDdlItems-module__header-root__1olPF"};